import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './Login.css';
import { login, changeForm, pageUnload } from '../../actions';
import FormComponent from '../../components/FormComponent';
import Form from '../../components/Form';

const mapStateToProps = state => ({
  formState: state.auth.formState,
  isLoading: state.auth.isFetching,
  errorMessage: state.auth.errorMessage,
  user: state.auth.user
});

const mapDispatchToProps = {
  onNavigateToRegisterPage: to => (dispatch, getstate, { history }) => {
    history.push(to);
  },
  onLoginClick: () => async (dispatch, getState, { history }) => {
    const { formState } = getState().auth;
    const res = await dispatch(login(formState));
    if (!res.error) {
      history.replace('/app');
    }
  },
  onChange: event => (dispatch, getState) => {
    event.preventDefault();
    const { formState } = getState().auth;
    dispatch(
      changeForm({
        ...formState,
        [event.target.name]: event.target.value
      })
    );
  },
  onUnload: () => dispatch => {
    dispatch(pageUnload());
  }
};

const FormType = {
  username: PropTypes.string,
  password: PropTypes.string.isRequired
};

class Login extends React.Component {
  static contextTypes = { fetch: PropTypes.func.isRequired };

  static propTypes = {
    title: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string.isRequired,
    formState: PropTypes.shape(FormType).isRequired,
    onLoginClick: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onUnload: PropTypes.func.isRequired,
    onNavigateToRegisterPage: PropTypes.func.isRequired
  };

  state = {
    recaptchaFailed: false,
    recaptchaCompleted: false
  };

  componentDidMount() {
    setTimeout(() => {
      window.grecaptcha.render('g-recaptcha', {
        sitekey: '6Ld700YUAAAAAECUF4wYras641n5pZSopQBoEBOL',
        callback: this.grecaptchaCallback
      });
    }, 300);
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  grecaptchaCallback = async response => {
    const res = await this.context.fetch('/api/recaptcha', {
      method: 'POST',
      body: JSON.stringify({
        'grecaptcha-response': response
      })
    });

    if (res.ok) {
      this.setState({
        recaptchaFailed: false,
        recaptchaCompleted: true
      });
    }
  };

  handleNavigateToRegisterPage = event => {
    event.preventDefault();
    this.props.onNavigateToRegisterPage(event.target.getAttribute('href'));
  };

  handleFormSubmit = event => {
    event.preventDefault();
    if (
      !this.state.recaptchaCompleted &&
      window.grecaptcha.getResponse() === ''
    ) {
      this.setState({
        recaptchaFailed: true
      });
      return;
    }
    this.props.onLoginClick();
  };

  render() {
    const {
      title,
      formState,
      isLoading,
      errorMessage,
      onLoginClick,
      onChange
    } = this.props;
    return (
      <div className="container-fluid">
        <div className="row">
          <div className={s.panel}>
            <Form
              title={title}
              isLoading={isLoading}
              loadingMessage="Logging in..."
              errorMessage={errorMessage}
              onFormSubmit={this.handleFormSubmit}
            >
              <div className={s.field}>
                <i className={cx(s.icon, 'fa', 'fa-envelope')} />
                <FormComponent
                  name="username"
                  type="email"
                  value={formState.username}
                  onChange={onChange}
                  placeholder="email"
                  required
                />
                <div className={s.iconPlaceholder} />
              </div>
              <div className={s.field}>
                <i className={cx(s.icon, 'fa', 'fa-lock')} />
                <FormComponent
                  name="password"
                  type="password"
                  value={formState.password}
                  onChange={onChange}
                  placeholder="password"
                  required
                />
                <div className={s.iconPlaceholder} />
              </div>
              <div className="d-flex flex-column justify-content-center">
                <a href="/forget-password" role="link" className="m-2">
                  Forget password?
                </a>
                <a
                  href="/register"
                  className="m-2"
                  onClick={this.handleNavigateToRegisterPage}
                >
                  New here? Join Us
                </a>
              </div>
              <div className={this.state.recaptchaFailed ? s.recaptcha : null}>
                <div id="g-recaptcha" />
                {this.state.recaptchaFailed
                  ? <p className={s.recaptchaFailedMessage}>
                      Please verify that you are not a robot.
                    </p>
                  : null}
              </div>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(s)(Login)
);



// WEBPACK FOOTER //
// ./src/routes/login/Login.js